/* eslint-disable no-useless-escape */
export const ValidationRules = {
  req: v => {
    let res = true
    if(v === `` || v === null || v === undefined) res = 'Обязательное поле'
    return res
    // !!v || 'Обязательное поле'
  },
  email: v => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return v ? pattern.test(v) || 'Неверный формат email' : true
  },
  tel: v => {
    const pattern = /^\+7\s{1}\(\d{3}\)\s{1}\d{3}\-\d{2}\-\d{2}$/
    return v ? pattern.test(v) || 'Неверный формат номера телефона' : true
  },
  date: v => {
    let pattern = /^\d{2}[./-]\d{2}[./-]\d{4}$/
    return v ? pattern.test(v) || 'Неверный формат даты': true
  },
  cyr: v => /^[а-яё ]*$/i.test(v) || 'Только кириллические символы',
  number: v => /^[0-9.]*$/i.test(v) || `Только цифры`,
}
